import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { QuillModule } from 'ngx-quill';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { CreateMessage } from '@app/app/store/messages/messages.actions';

@Component({
  selector: 'app-add-message',
  templateUrl: './add-message.component.html',
  styleUrls: ['./add-message.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    QuillModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddMessageComponent {
  dealId = input.required<number>();
  messageAdded = output<void>();
  isSaving = signal(false);

  quillFormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(9), // Really 2 chars, because 7 are the wrapping paragraph tags
    Validators.maxLength(2000),
  ]);
  quillModules = {
    toolbar: '#custom-quill-toolbar',
  };

  constructor(protected _store: Store) {}

  addMessage(message: string): void {
    this.isSaving.set(true);
    this._store
      .dispatch(
        new CreateMessage(
          this.dealId(),
          message,
        )
      )
      .subscribe({
        complete: () => {
          this.isSaving.set(false);
          this.messageAdded.emit();
          this.quillFormControl.reset();
        },
        error: () => {
          this.isSaving.set(false);
          this.quillFormControl.setErrors({ serverError: true });
        },
      });
  }
}
